const ASSETS_API = process.env.VUE_APP_API;

const parseToHtml = content => {
  return new DOMParser().parseFromString(content, "text/html");
};

export const convertAssetsPathToRelativeLinks = content => {
  let htmlElementFromContent = parseToHtml(content);

  htmlElementFromContent.querySelectorAll("img").forEach(e => {
    if (e.dataset.image !== undefined) {
      e.src = new URL(e?.src)?.pathname;
    }

    if (e.srcset) {
      e.srcset = e.srcset.replaceAll(ASSETS_API, "");
    }
  });

  htmlElementFromContent.querySelectorAll("video").forEach(e => {
    e.src = new URL(e?.src)?.pathname;
    e.poster = new URL(e?.poster)?.pathname;
  });

  return htmlElementFromContent;
};

export const convertAssetsPathToAbsoluteLinks = content => {
  if (!content) return "";
  let htmlElementFromContent = parseToHtml(content);

  htmlElementFromContent.querySelectorAll("img").forEach(e => {
    if (e.dataset.image !== undefined) {
      e.src = ASSETS_API + new URL(e?.src)?.pathname;
    }

    if (e.srcset) {
      e.srcset = e.srcset.replaceAll("/media/custom", `${ASSETS_API}/media/custom`);
    }
  });

  htmlElementFromContent.querySelectorAll("video").forEach(e => {
    e.src = ASSETS_API + new URL(e?.src)?.pathname;
    e.poster = process.env.VUE_APP_API + new URL(e?.poster)?.pathname;
  });

  return htmlElementFromContent.body.innerHTML;
};
